module.exports = __webpack_public_path__ + "static/media/bg.776c7757.png";